import { FeatureImpl } from './Feature';
import { LineString } from 'ol/geom';
import { Stroke, Style } from 'ol/style';
import { Utils } from './Utils';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature as OLFeature } from 'ol';
export class RouteImpl extends FeatureImpl {
    constructor(data, config, arrival, departure, aircraft) {
        super(data, config);
        this.arrival = arrival;
        this.departure = departure;
        this.aircraft = aircraft;
        this._style = new Style({
            stroke: new Stroke({
                color: this._config.routeColor,
                width: 1
            })
        });
        this._activeStyle = new Style({
            stroke: new Stroke({
                color: this._config.routeColor,
                width: 1
            })
        });
    }
    get isInSky() {
        return this.data.pathCompletion > 0 && this.data.pathCompletion < 100;
    }
    create() {
        const flight = this.data;
        const features = [];
        const coordsDep = [flight.departure.airport.latitude, flight.departure.airport.longitude];
        const coordsArr = [flight.arrival.airport.latitude, flight.arrival.airport.longitude];
        const coords = Utils.getCirclePoints(coordsDep, coordsArr);
        const line = new LineString(coords);
        line.transform('EPSG:4326', 'EPSG:3857');
        features.push(new OLFeature({
            geometry: line,
            finished: false
        }));
        this._layer = new VectorLayer({
            style: this.style,
            zIndex: 3,
            source: new VectorSource({
                features: features
            })
        });
        return this._layer;
    }
    set isActive(value) {
        this.layer.setStyle(value ? this._activeStyle : this._style);
    }
    isFromAirport(airport) {
        return airport.data.iata === this.data.departure.airport.iata;
    }
}
